import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Constants } from '@config/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { ILabel } from 'app/models';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class LabelService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) { }

  findAllLabelsByCustomerAndType = (
    customerId: number,
    type: string
  ): Observable<ILabel[]> =>
    this.http
      .get<ILabel[]>(
        `${this.constants.MACHINES_ENDPOINT}/labels`
        + `?customerId=${customerId}`
        + `&type=${type}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

}
